import { render, staticRenderFns } from "./editScratchMould.vue?vue&type=template&id=40cf5dcc&scoped=true"
import script from "./editScratchMould.vue?vue&type=script&lang=js"
export * from "./editScratchMould.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cf5dcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40cf5dcc')) {
      api.createRecord('40cf5dcc', component.options)
    } else {
      api.reload('40cf5dcc', component.options)
    }
    module.hot.accept("./editScratchMould.vue?vue&type=template&id=40cf5dcc&scoped=true", function () {
      api.rerender('40cf5dcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsteacher/teacher/editScratchMould.vue"
export default component.exports